import {
    WorkspaceColumn,
    WorkspaceSortValue,
} from "@common/types/views/workspaceViews";
import { ViewConfig } from "@lib/views";
import { NameCell, WorkspaceDetailsRow } from "./cells/NameCell";
import { EntitiesCell } from "./cells/EntitiesCell";
import { TeamCell } from "./cells/TeamCell";

export const workspaceViewConfig: ViewConfig<
    WorkspaceDetailsRow,
    WorkspaceColumn,
    WorkspaceSortValue
> = {
    columns: {
        [WorkspaceColumn.NAME]: {
            accessorKey: "workspace.name",
            name: "Workspace",
            cell: NameCell,
            sort: {
                asc: WorkspaceSortValue.NAME_ASC,
                desc: WorkspaceSortValue.NAME_DESC,
            },
        },
        [WorkspaceColumn.ENTITIES]: {
            accessorKey: "entities",
            name: "Entities",
            cell: EntitiesCell,
        },
        [WorkspaceColumn.TEAM]: {
            accessorKey: "assignments",
            name: "Team",
            cell: TeamCell,
        },
    },
};
